import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { ISetSearchParams } from 'components/core/types'
import { AppDispatch } from 'components/store/state/store'
import { useTranslation } from 'react-i18next'
import ArrowButton from 'components/ui/buttons/ArrowButton'
import { updateCurrentStep } from 'components/core/state/actions'
import { css, StyleSheet } from 'aphrodite'
import constants from 'utils/constants'

const mapDispatch = (dispatch: AppDispatch) => ({
  updateStep: (step: number, setSearchParams: ISetSearchParams) => {
    dispatch(updateCurrentStep(step, setSearchParams))
  },
})
const connector = connect(null, mapDispatch)

interface IAppointmentButtonProps extends ConnectedProps<typeof connector> {
  step: number
}

const AppointmentButton = ({ step, updateStep }: IAppointmentButtonProps) => {
  const [, setSearchParams] = useSearchParams()
  const { t } = useTranslation()
  const handleClick = () => updateStep(step, setSearchParams)
  return (
    <ArrowButton buttonStyle={css(styles.button)} onClick={handleClick} text={t('take-appointment')} />
  )
}
const styles = StyleSheet.create({
  button: {
    background: constants.colors.green,
  },
})
export default connector(AppointmentButton)
